<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container bottom-footer">
        <!-- Outer Row -->
        <div class="row justify-content-center mt-n3">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                <LogoColor formatting="logo-center" width="250px"></LogoColor>
                <div class="row">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                        <h4>Termos de uso</h4>
                        <p class="text-justify">Antes de continuar, por gentileza, leia atentamente os termos de uso da
                            plataforma e clique
                            em "Aceitar termos" para que seja possível prosseguir.</p>
                    </div>
                </div>
                <div class="row mb-4">
                    <div class="col-lg-12 col-xs-12 col-sm-12 editor-container border-quill">
                        <editor-text-disabled ref="myChild" contentType="html">
                        </editor-text-disabled>
                    </div>
                </div>
                <div class="row mb-4 float-right">
                    <div class="col-lg-12 col-xs-12 col-sm-12 editor-container">
                        <button class="btn btn-success" @click="acceptTerm"><i class="fa fa-check"></i> Li e aceito os
                            termos de uso</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import { mask } from 'vue-the-mask'
import LogoColor from '../img/logo-color.vue';
import { handleRequestErrors } from '@/handleErrors';
import editorTextDisabled from '../util/editor-text-disabled.vue';
import api from '@/api';

export default {
    directives: { mask },
    components: {
        LogoColor, Loading, editorTextDisabled
    },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            url_api: '',
            enable_error_list: false,
            errors: []
        }
    },
    computed: {
        isDisabled: function () {
            return this.authentication.password != '' && this.authentication.confirm_password != '';
        }
    },
    mounted() {
        this.isLoading = false;
        this.loadData();

    },
    methods: {
        async loadData() {
            let text = localStorage.getItem('text_term_use');
            this.$refs.myChild.updateTextEditor(text);
        },
        onCancel() { },
        acceptTerm(event) {
            event.preventDefault();
            this.isLoading = true;
            api.post('/user/acceptTermUse')
                .then(() => {
                    localStorage.setItem('term_use', true);
                    this.$router.push('/');
                    this.isLoading = false;
                }).catch(error => {
                    this.isLoading = false;
                    if (error.status == 422) {
                        let response_errors = error.response.data.errors;
                        this.errors = response_errors;
                        this.enable_error_list = true;
                    }
                    handleRequestErrors(error.status);
                })
        }
    }
}
</script>

<style>
* {
    scrollbar-width: none;
}

.bottom-footer {
    margin-top: 0%;
    margin-bottom: 40px;
}

.editor-container {
    width: 100%;
}

.border-quill{
    border: 1px solid #000;
}
</style>